import { MWheelTimePicker, useIstTelefon } from "@vimaana/ui";
import type { CSSProperties } from "react";

/**
 * Zeiteingabe der Planung — am Telefon das Rad, am Schreibtisch das Zahlenfeld.
 *
 * Zwei Bedienungen fuer dieselbe Sache, weil die Lage eine andere ist: auf dem
 * Telefon erspart das Rad die Zifferntastatur und trifft das Viertelstunden-
 * raster von selbst; mit Tastatur ist "0815" getippt schneller als jedes Rad.
 * Die Entscheidung steht nur hier, damit nicht jede Aufrufstelle sie neu faellt.
 *
 * Der Rad-Knopf traegt aus dem Paket die Klasse `m-time-input`, deren Farben aus
 * der Planer-Palette (`--m-*`) kommen. Die gibt es in Kontor nicht — darum setzt
 * `planung.css` unter `.pl-zeitfeld` die Kontor-Tokens darueber. Ohne das steht
 * der Knopf farblos im Raum.
 */
export function Zeitfeld({ value, onChange, stil, groesse, label, ariaLabel, disabled }: {
  value: string;
  onChange: (v: string) => void;
  /** Feldstil der Schreibtisch-Variante (timeSm / timeLg). */
  stil?: CSSProperties;
  /** Steuert die Breite des Rad-Knopfs am Telefon. */
  groesse?: "sm" | "lg";
  /** Ueberschrift im Rad-Blatt. */
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
}) {
  const telefon = useIstTelefon();

  if (telefon) {
    return (
      <span className={`pl-zeitfeld pl-zeitfeld-${groesse ?? "sm"}`}>
        <MWheelTimePicker value={value} onChange={onChange} label={label ?? ariaLabel} disabled={disabled} />
      </span>
    );
  }

  return (
    <input
      type="time"
      step={900}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      style={stil}
      aria-label={ariaLabel}
    />
  );
}
